var map = {
	"./avatar_icon1.png": 4331,
	"./avatar_icon2.png": 90512,
	"./avatar_icon3.png": 96761,
	"./avatar_icon4.png": 94342,
	"./avatar_icon5.png": 75887,
	"./avatar_icon6.png": 54420,
	"./avatar_icon7.png": 75549,
	"./avatar_icon8.png": 64778,
	"./avatar_icon9.png": 96691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43689;